<template>
  <div class="class-wrapper">

    <div class="bg">
    </div>
    <div class="class-bg">
      <div class="title-wrapper">
        <v-title class="title" page-title="我的课时"></v-title>
      </div>
      <div class="content-wrapper">
        <div class="release-wrapper">
          <!-- <router-link to="/post-msg">
            <div class="publish">
              <span class="icon-plus"></span><span>发布</span>
            </div>
          </router-link> -->
          <el-date-picker
            size="mini"
            v-model="value"
            type="year"
            placeholder="选择年"
            class="narrow-datepicker"
            @change="handleChange"
            :picker-options="pickerOptions">
          </el-date-picker>
          <template v-if="isCustom"> 
            <router-link to="/signature/0/0/true">
              <div class="publish" @click="historyClass">
                <span>历史课时>></span>
              </div>
            </router-link>
          </template>
        </div>
        <mt-loadmore id="scroll-wrapper" :top-method="refresh"  ref="refresh">
          <ul class="list-wrapper"
              v-infinite-scroll="loadMore"
              infinite-scroll-disabled="disable"
              infinite-scroll-distance="10">
            <news-item v-for="item in newsList"
                       v-bind:item="item"
                       :key="item.id">
            </news-item>
          </ul>
           <!--loadingState != 1(正常隐藏状态) 显示底部状态-->
          <div v-show="loadingState != 1" class="bottom">
            <!-- loadingState == 2 显示加载动画状态-->
            <mt-spinner v-show="loadingState == 2" type="fading-circle" color="#cba164"></mt-spinner>
            <span v-text="stateText"></span>
          </div>
        </mt-loadmore>

      </div>
    </div>

    <!--<picture-view v-show="imgs.length !== 0"-->
    <!--v-bind:index="index"-->
    <!--v-bind:imgs="imgs"-->
    <!--v-on:close="handleClose"></picture-view>-->
  </div>


</template>

<script>
  import { Toast, Loadmore } from 'mint-ui';
  import MyClass from '../api/myclass';
  import Vue from 'vue';
  import VTitle from '../components/VTitle.vue';
  import NewsItem from '../components/NewsItem.vue';
  import PictureView from '@/views/PictureView';
  export default{
    name: 'my-class',
    data () {
      return {
        newsList: [],
        value:'',
        isCustom:false,
        pickerOptions: {
          disabledDate(date) {
            // 获取当前时间的年和月份
            const year = new Date().getFullYear();
            // 将不可选的月份设为选择当前月份之后的月份
            return date.getFullYear() > year;
          }
        },
        bScroll: '',
        iScroll: '',
        // currentPage: 0,
        // totalPage: 0,
        // disable: false,
        largeView: false,
        imgs: [],
        index: 0,
        scrollTop: 0,
        scrollDiv: {},
        loadingState: 1 // 1-正常隐藏状态 2-加载状态 3-到底状态 4-nothing状态 5-网络情况差
      };
    },
    methods: {
      //历史课时
      historyClass(){
        this.customImage()
      },
      customImage(){
        //调查询接口
        MyClass.getCustomSignatureImage().then(response =>{
          if(response.data.length > 0){
            this.isCustom = true;
            //获取当前点击查看的签字信息
            this.$store.commit('SelectSignature',response.data[0].imgUrl);
            //存储自定义签字图片id
            this.$store.commit('CustomSignature',response.data[0].id);
          }else{
            this.isCustom = false;
          }
        }).catch(err=>{
          console.log(err);
        })
      },
      handleChange(e){
        this.setLoadingState(2); // 设置加载状态
        const date = new Date(e);
        const year = date.getFullYear();
        MyClass.getSignatureList(year).then((response)=>{
            this.newsList = []
            if(response.rows.length!=0){
              setTimeout(()=>{
                this.setLoadingState(1);
                this.newsList = response.rows;
              },300)
              
            }else{
              this.setLoadingState(4);
            }
        }).catch((error)=>{
          console.log(error);
        })
        
        
      },
      refresh () {
        // this.currentPage = 1;
        this.getList();
        this.$refs.refresh.onTopLoaded();
      },
      loadMore() {
        // this.disable = true;
        // this.currentPage++;
        this.getList();
      },
      getList() {
        this.setLoadingState(2); // 设置加载状态

        //首次进入默认查询今年的签字记录
        const year = new Date().getFullYear();
        MyClass.getSignatureList(year).then((response)=>{
      // }).catch((error)=>{
      //   console.log(error);
      // })
        // MyClass.getNewsList().then(response => {
          // if (response.errno === '0') {
            
            //如果得到的页数大于1就循环数据依个赋值
            // if (this.currentPage > 1) {
            //   for (let i = 0; i < response.row.length; i++) {
            //     this.newsList.push(response.row[i]);
            //   }
            // } else {
              //第一页则就直接赋值，给数组
              this.newsList = response.rows;
            // }
            this.setLoadingState(1);
            // this.currentPage = response._meta.currentPage;
            // this.totalPage = response._meta.pageCount;
            // 判断是否可以继续加载
            // this.disable = this.currentPage >= this.totalPage;
            // if (this.disable) {
            //   if (this.newsList.length === 0) {
            //     this.setLoadingState(4);
            //   } else {
            //     this.setLoadingState(3);
            //   }
            // } else {
            //   // 还有下一页正常隐藏
            //   this.setLoadingState(1);
            // }
          // } else {
          //   Toast({message: response.message, position: 'middle', duration: 3000});
          // }
        }).catch(e => {
          this.setLoadingState(5);
        });
      },
      handleClose() {
        this.imgs = [];
        this.index = 0;
      },
      setLoadingState(state) {
        this.loadingState = state;
      }
    },
    computed: {
      stateText() {
        let text = '';
        switch (this.loadingState) {
          case 1:
            text = '';
            break;
          case 2:
            text = '加载中...';
            break;
          case 3:
            text = '到底了...';
            break;
          case 4:
            text = '暂无记录';
            break;
          case 5:
            text = '请检查您的网络';
            break;
        }
        return text;
      }
    },
    created() {
      let _that = this;
      Vue.nextTick(function () {
        _that.scrollDiv = document.getElementById('scroll-wrapper');
        _that.scrollDiv.onscroll = function () {
          _that.scrollTop = this.scrollTop;
        };
      });
      //页面加载时默认获取当前年的签字数据
      this.getList()
    },
    activated() {
      this.scrollDiv.scrollTop = this.scrollTop;
    },
    mounted() {
    //获取自定义签字图片，判断是否存在，用来控制页面是否显示入口
      this.customImage()
    },
    components: {VTitle, NewsItem, Loadmore, PictureView},
    route: {}
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .class-wrapper {

    .bg {
      position: absolute;
      top: px2rem(128);
      width: px2rem(704);
      margin: 0 px2rem(27);
      height: px2rem(1004);
      @include bg-img('../assets/img/common/parentbgbase');
    }
    .class-bg {
      position: absolute;
      top: px2rem(128);
      width: px2rem(704);
      margin: 0 px2rem(27);
      .title-wrapper {
        position: relative;
      }
      .title {
        position: absolute;
        top: px2rem(-73);
        left: px2rem(135);
      }

      .content-wrapper {
        padding: px2rem(30) px2rem(45);
        .release-wrapper {
          margin-top: px2rem(30);
          display: flex;
          justify-content: space-between;
          align-items: center;
          .narrow-datepicker{
            .el-date-editor {
              width: 180px; /* 调整宽度为合适的值 */
            }
            .el-picker-panel {
              width: 200px; /* 调整宽度为合适的值 */
            }
          }
          .publish{
            font-size: px2rem(30);
          }
        //   position: relative;
        //   font-size: 0;
        //   font-family: 'SXSLST';
        //   border-bottom: px2rem(4) solid #cba164;
        //   border-radius: px2rem(4);

        //   line-height: px2rem(120);
        //   height: px2rem(120);

        //   .publish {
        //     position: absolute;
        //     right: px2rem(60);
        //     color: white;
        //     height: 100%;
        //     & > span {
        //       display: inline-block;
        //       font-size: px2rem(48);
        //       @include text-shadow(2, 2, rgba(137, 64, 0, 0.75));
        //     }
        //     .icon-plus {
        //       height: px2rem(70);
        //       width: px2rem(66);
        //       margin: px2rem(25) px2rem(12) 0 0;
        //       vertical-align: top;
        //       @include bg-img('../assets/img/common/icon_plus');
        //     }
        //   }

        }
        #scroll-wrapper {
          height: px2rem(910);
          width: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
          font-size: px2rem(30);
          color: #3a230a;
          ::-webkit-scrollbar {
            width: 20px;
            height: 20px;
          }

          .list-wrapper {
            margin-top: px2rem(25);
          }

          .bottom {
            margin-top: px2rem(10);
            height: px2rem(70);
            line-height: px2rem(70);
            text-align: center;
            span {
              display: inline-block;
              vertical-align: middle;
              &:nth-child(2) {
                margin-left: px2rem(20);
              }
            }
          }
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// MyClass.vue?f7221a76